<template lang="pug">
  dialogs(:show.sync="visible" :option="{ size: 'lg' }" :title="title")
    b-container(fluid :class="{ 'is-mobile': isMobile }")
      div.context
        b-form
          form-approval-request(:form="detail")
          b-form-group.request-date.d-flex.align-items-center(
            content-cols-sm
            :label="$t('management_page.approval_status')"
            label-for="state"
            label-cols-sm="2"
            label-align-sm="left"
          )
            b-radio-group#state(
              v-model="form.approve_state"
              :options="[{text: this.$t('registration'), value: 0}, {text: this.$t('approval'), value: 2}, {text: this.$t('reject-submit'), value: 1}, {text: this.$t('cancel'), value: 4}]"
              disabled
            )

          b-form-group.request-date(
            content-cols-sm
            :label="$t('management_page.approval_datetime')"
            label-for="app-period-start"
            label-cols-sm="2"
            label-align-sm="left"
          )
            b-input-group.time-group
              b-form-datepicker#app-period-start.mt-0.c-w-5(
                v-model="detail.proposal_time",
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                :disabled="true"
              )
              b-input-group-append.d-flex.align-items-center
                b-select.ml-2.h-100(v-model="detail.proposal_time_hour" :options="hourOptions" size="sm" :disabled="true")
                span.ml-1 {{$t('hour')}}
                b-select.ml-2.h-100(v-model="detail.proposal_time_min" :options="minOptions" size="sm" :disabled="true")
                span.ml-1 {{$t('minute')}}
    .modal-footer
      b-button(variant="secondary" size="sm" @click="visible = false" pill) {{$t('submit')}}
</template>

<script>
import Dialogs from "@/components/mixins/dialog/index.vue"
import FormApprovalRequest from "./formApprovalRequest.vue"
import _ from "lodash"
import moment from "moment"

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    Dialogs,
    FormApprovalRequest,
  },
  computed: {
    hourOptions() {
      return _.range(0, 24).map(item => {
        const num = item < 10 ? "0" + item : item
        return { text: num, value: num }
      })
    },
    minOptions() {
      return _.range(0, 60).map(item => {
        const num = item < 10 ? "0" + item : item
        return { text: num, value: num }
      })
    },
    isMobile() {
      if (!this.$mq) return false
      if (this.$mq.resize && this.$mq.isMobile()) return true
      return false
    },
  },
  watch: {
    show(newVal) {
      this.visible = newVal
      if (newVal) {
        this.detail = _.cloneDeep(this.form)
        this.detail.device_alias = `${this.detail.device_name} (${this.detail.manager_pri_ip})`
        this.detail.approver = `${this.detail.approver_name} (${this.detail.approver_id})`

        this.detail.start_time = moment(this.form.start_time).format("YYYY-MM-DD")
        this.detail.start_time_hour = moment(this.form.start_time).format("HH")
        this.detail.start_time_min = moment(this.form.start_time).format("mm")

        this.detail.end_time = moment(this.form.end_time).format("YYYY-MM-DD")
        this.detail.end_time_hour = moment(this.form.end_time).format("HH")
        this.detail.end_time_min = moment(this.form.end_time).format("mm")

        this.detail.create_time = moment(this.form.create_time).format("YYYY-MM-DD")
        this.detail.create_time_hour = moment(this.form.create_time).format("HH")
        this.detail.create_time_min = moment(this.form.create_time).format("mm")

        this.detail.proposal_time = moment(this.form.proposal_time).format("YYYY-MM-DD")
        this.detail.proposal_time_hour = moment(this.form.proposal_time).format("HH")
        this.detail.proposal_time_min = moment(this.form.proposal_time).format("mm")
      }
    },
    visible(newVal) {
      this.$emit("update:show", newVal)
    },
  },
  data() {
    return {
      visible: false,
      detail: {},
      kindOptions: [
        { text: this.$t('manual_input'), value: 1 },
        { text: this.$t('management_page.remote_work'), value: 2 },
        { text: this.$t('management_page.incident_response'), value: 3 },
        { text: this.$t('management_page.dispatch'), value: 4 },
        { text: this.$t('management_page.maintenance'), value: 5 },
      ],
      postForm: {
        kind: 1,
        reason: "",
      },
    }
  },
}
</script>

<style lang="scss" scoped></style>
